/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import WsBundleVariantPicker from './WsBundleVariantPicker';
import WsVariantPickerControls from './WsVariantPickerControls';

const WsVariantPickerBlock = ({
  isBundleProduct,
  ecomStoreProduct,
  onVariantChange,
  onInputChange,
  onDesignAnswerChange,
  onBundleProductVariantSelect,
  selectedVariants,
  selectedVariantsInfo,
  selectedProductVariantsState,
  storeProductOptions,
  submitting,
  mediaQueries,
  config,
  baseStoreUrl,
  onNavigate,
  editModeEnabled,
  adjustments,
  isCartEdit,
  enableImageNotAvailablePreview
}) =>
  isBundleProduct ? (
    <WsBundleVariantPicker
      adjustments={adjustments}
      baseStoreUrl={baseStoreUrl}
      config={config}
      ecomStoreProduct={ecomStoreProduct}
      editModeEnabled={editModeEnabled}
      enableImageNotAvailablePreview={enableImageNotAvailablePreview}
      isBundleProduct={isBundleProduct}
      isCartEdit={isCartEdit}
      mediaQueries={mediaQueries}
      onBundleProductVariantSelect={onBundleProductVariantSelect}
      onDesignAnswerChange={onDesignAnswerChange}
      onInputChange={onInputChange}
      onNavigate={onNavigate}
      onVariantChange={onVariantChange}
      selectedProductVariantsState={selectedProductVariantsState}
      selectedVariantsInfo={selectedVariantsInfo}
      storeProductOptions={storeProductOptions}
      submitting={submitting}
    />
  ) : (
    <WsVariantPickerControls
      baseStoreUrl={baseStoreUrl}
      config={config}
      ecomStoreProduct={ecomStoreProduct}
      editModeEnabled={editModeEnabled}
      isBundleProduct={isBundleProduct}
      isCartEdit={isCartEdit}
      mediaQueries={mediaQueries}
      onDesignAnswerChange={onDesignAnswerChange}
      onInputChange={onInputChange}
      onNavigate={onNavigate}
      onVariantChange={onVariantChange}
      selectedProductVariantsState={selectedProductVariantsState[0]}
      selectedVariant={selectedVariants[0]}
      submitting={submitting}
      variantOptions={storeProductOptions[0]?.variantOptions || []}
    />
  );

WsVariantPickerBlock.propTypes = {
  adjustments: PropTypes.object,
  baseStoreUrl: PropTypes.string,
  config: PropTypes.object,
  ecomStoreCartProductInputAnswers: PropTypes.array,
  ecomStoreProduct: PropTypes.object,
  editModeEnabled: PropTypes.bool,
  enableImageNotAvailablePreview: PropTypes.bool,
  isBundleProduct: PropTypes.bool,
  isCartEdit: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onBundleProductVariantSelect: PropTypes.func,
  onDesignAnswerChange: PropTypes.func,
  onInputChange: PropTypes.func,
  onNavigate: PropTypes.func,
  onVariantChange: PropTypes.func,
  selectedProductVariantsState: PropTypes.array,
  selectedVariants: PropTypes.array,
  selectedVariantsInfo: PropTypes.array,
  storeProductOptions: PropTypes.array,
  submitting: PropTypes.bool,
  variantOptions: PropTypes.array
};

export default WsVariantPickerBlock;
